var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(Object.assign({}, _vm.backgroundColor)),attrs:{"id":"loading"}},[_c('img',{attrs:{"src":require("@/assets/img/loading.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }